import { render } from "./VsudButton.vue?vue&type=template&id=55ae748d&scoped=true"
import script from "./VsudButton.vue?vue&type=script&lang=js"
export * from "./VsudButton.vue?vue&type=script&lang=js"

import "./VsudButton.vue?vue&type=style&index=0&id=55ae748d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ae748d"]])

export default __exports__